<template>
  <section :id="$style.hidekiinfo_visual">
    <div :class="$style.left_area">
      <main-title
        v-observe-visibility="visibilityChanged_title"
        :class="{[$style.position]: true, ['animated slideInDown']: isVisible_title}"
        :main_title="'松井秀喜情報'"
        :sub_title="'Hideki Matsui Information'"
        :color="'#403f3f'"
      ></main-title>
      <!-- 野球に関する情報 -->
      <table :id="$style.baseball_info">
        <tr>
          <td :class="$style.title">
            <span>ニックネーム：</span>
            <span>
              <small>Nickname：</small>
            </span>
          </td>
          <td :class="$style.detail">
            <span>ゴジラ</span>
            <span>
              <small>GODZILLA</small>
            </span>
          </td>
        </tr>
        <tr>
          <td :class="$style.title">
            <span>投打：</span>
            <span>
              <small>Pitching &amp; Batting：</small>
            </span>
          </td>
          <td :class="$style.detail">
            <span>右投・左打</span>
            <span>
              <small>Right &amp; Left</small>
            </span>
          </td>
        </tr>
        <tr>
          <td :class="$style.title">
            <span>ポジション：</span>
            <span>
              <small>Position：</small>
            </span>
          </td>
          <td :class="$style.detail">
            <span>外野手</span>
            <span>
              <small>Outfielder</small>
            </span>
          </td>
        </tr>
        <tr>
          <td :class="$style.title">
            <span>好きな食べ物：</span>
            <span>
              <small>Favorite food：</small>
            </span>
          </td>
          <td :class="$style.detail">
            <span>寿司</span>
            <span>
              <small>Sushi</small>
            </span>
          </td>
        </tr>
      </table>

      <!-- 体型に関する情報 -->
      <table :id="$style.body_shape_info">
        <tr>
          <td :class="$style.title">
            <span>身長：</span>
            <span>
              <small>Height：</small>
            </span>
          </td>
          <td :class="$style.detail">
            <span>188 cm</span>
            <span>
              <small>188 cm</small>
            </span>
          </td>
        </tr>
        <tr>
          <td :class="$style.title">
            <span>体重：</span>
            <span>
              <small>Weight：</small>
            </span>
          </td>
          <td :class="$style.detail">
            <span>105 kg</span>
            <span>
              <small>105kg</small>
            </span>
          </td>
        </tr>
        <tr>
          <td :class="$style.title">
            <span>肩幅：</span>
            <span>
              <small>Shoulder width：</small>
            </span>
          </td>
          <td :class="$style.detail">
            <span>52 cm</span>
            <span>
              <small>52 cm</small>
            </span>
          </td>
        </tr>
        <tr>
          <td :class="$style.title">
            <span>ウェスト：</span>
            <span>
              <small>Waist：</small>
            </span>
          </td>
          <td :class="$style.detail">
            <span>90 cm</span>
            <span>
              <small>90 cm</small>
            </span>
          </td>
        </tr>
        <tr>
          <td :class="$style.title">
            <span>血液型：</span>
            <span>
              <small>Blood group：</small>
            </span>
          </td>
          <td :class="$style.detail">
            <span>O型</span>
            <span>
              <small>O-group</small>
            </span>
          </td>
        </tr>
      </table>
    </div>

    <div :class="$style.right_area">
      <div :id="$style.fig">
        <figure :id="$style.hideki_fig"></figure>
      </div>
      <more-info-big-button
        v-observe-visibility="visibilityChanged_btn"
        :class="{[$style.moreinfo_button]: true, ['animated slideInUp']: isVisible_btn}"
        :title="'More Info'"
        :link="'/hidekiinfo'"
        :color="'#403f3f'"
        :background="'#ffb34b'"
      ></more-info-big-button>
      <div :class="$style.moreinfo_detail">ホームラン情報・全記録・年表等</div>
    </div>
  </section>
</template>

<script lang="ts">
import Vue from "vue";
import MainTitle from "@/components/atoms/MainTitle.vue";
import MoreInfoBigButton from "@/components/atoms/MoreInfoBigButton.vue";

export default Vue.extend({
  name: "HidekiInfoHomeVisual",

  components: {
    MainTitle,
    MoreInfoBigButton
  },
  data() {
    return {
      isVisible_title: Boolean,
      isVisible_btn: Boolean
    };
  },
  methods: {
    visibilityChanged_title(isVisible) {
      this.isVisible_title = isVisible;
    },
    visibilityChanged_btn(isVisible) {
      this.isVisible_btn = isVisible;
    }
  }
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  $fig_height: 390px;
  $fig_width: 180px;

  #hidekiinfo_visual {
    width: 100%;
    background-color: #fddea2;
    // height: 700px;
    display: grid;
    grid-template-columns: 1fr repeat(3, 100px) 1fr;
    grid-template-rows: 60px 1fr 60px;
    position: relative;
    z-index: 1;
  }

  // .left_areaのタグを右揃えにする
  .position {
    text-align: center !important;
  }

  .left_area {
    font-size: 12px;
    grid-column: 2/5;
    grid-row: 2/3;
    table {
      margin-top: 40px;
      tr {
        display: flex;
        margin: 7px 0px;
        td {
          display: flex;
          flex-direction: column;
          text-align: right;
          span {
            height: 14px;
            small {
              white-space: nowrap;
            }
          }
        }
        .title {
          width: 100px;
        }
        .detail {
          width: 62px;
        }
      }
    }
  }

  .right_area {
    margin: 0;
    margin-top: 30px;
    grid-column: 2/5;
    grid-row: 2/3;
    #fig {
      height: $fig_height;
      width: $fig_width;
      margin-left: 153px;
      margin-top: 67px;
      #hideki_fig {
        height: 100%;
        width: 100%;
        background-image: url("../../../assets/hideki.png");
        background-size: $fig_width $fig_height;
        background-repeat: no-repeat;
        margin: 0;
      }
    }
    .moreinfo_button {
      margin: auto;
      margin-top: 25px;
    }
    .moreinfo_detail {
      width: 240px;
      margin: auto;
      margin-top: 8px;
      font-size: 15px;
      text-align: center;
      color: #403f3f;
    }
  }
}
@media only screen and (min-width: 1024px) {
  $fig_height: 400px;
  $fig_width: 190px;

  #hidekiinfo_visual {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fddea2;
    height: 800px;
  }

  // .left_areaのタグを右揃えにする
  .position {
    margin-left: auto;
  }

  .left_area {
    table {
      margin-top: 25px;
      tr {
        display: flex;
        margin: 7px 0px;
        td {
          display: flex;
          flex-direction: column;
          text-align: right;
          span {
            height: 20px;
            small {
              white-space: nowrap;
            }
          }
        }
        .title {
          width: 135px;
        }
        .detail {
          width: 85px;
        }
      }
    }
  }

  .right_area {
    margin: 0;
    margin-top: 30px;
    margin-left: 112px;
    // 縦に積む
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    // 中央寄せ
    align-items: center;
    #fig {
      height: $fig_height;
      width: $fig_width;
      #hideki_fig {
        height: 100%;
        width: 100%;
        background-image: url("../../../assets/hideki.png");
        background-size: $fig_width $fig_height;
        background-repeat: no-repeat;
        margin: 0;
      }
    }
    .moreinfo_button {
      margin-top: 10px;
    }
    .moreinfo_detail {
      width: 240px;
      margin-top: 8px;
    }
  }
}
</style>
